import React, { useEffect, useRef } from 'react';

const GridBackground = () => {
  const canvasRef = useRef(null);
  const timeRef = useRef(0);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let animationFrame;

    const resize = () => {
      const dpr = window.devicePixelRatio || 1;
      const rect = canvas.getBoundingClientRect();
      
      canvas.width = rect.width * dpr;
      canvas.height = rect.height * dpr;
      ctx.scale(dpr, dpr);
      canvas.style.width = `${rect.width}px`;
      canvas.style.height = `${rect.height}px`;
    };

    const drawGrid = (time) => {
      const width = canvas.width / (window.devicePixelRatio || 1);
      const height = canvas.height / (window.devicePixelRatio || 1);
      
      // Clear with the background color instead of transparent
      ctx.fillStyle = 'rgb(76, 29, 149)';
      ctx.fillRect(0, 0, width, height);
      
      // Grid settings
      const cellSize = 50;
      const rows = Math.ceil(height / cellSize) + 2;
      const cols = Math.ceil(width / cellSize) + 2;
      
      // Offset for smooth scrolling effect
      const offsetX = (time * 0.2) % cellSize;
      const offsetY = (time * 0.1) % cellSize;

      // Draw vertical lines
      ctx.strokeStyle = 'rgba(255, 255, 255, 0.1)';
      ctx.lineWidth = 1;

      for (let i = 0; i < cols; i++) {
        const x = i * cellSize - offsetX;
        ctx.beginPath();
        ctx.moveTo(x, -cellSize);
        ctx.lineTo(x, height + cellSize);
        ctx.stroke();
      }

      // Draw horizontal lines
      for (let i = 0; i < rows; i++) {
        const y = i * cellSize - offsetY;
        ctx.beginPath();
        ctx.moveTo(-cellSize, y);
        ctx.lineTo(width + cellSize, y);
        ctx.stroke();
      }

      // Draw dots at intersections
      ctx.fillStyle = 'rgba(255, 255, 255, 0.2)';
      for (let i = 0; i < cols; i++) {
        for (let j = 0; j < rows; j++) {
          const x = i * cellSize - offsetX;
          const y = j * cellSize - offsetY;
          
          // Add subtle movement to dots
          const dotOffset = Math.sin(time * 0.001 + i * 0.5 + j * 0.5) * 2;
          
          ctx.beginPath();
          ctx.arc(x + dotOffset, y, 1.5, 0, Math.PI * 2);
          ctx.fill();
        }
      }
    };

    const animate = () => {
      timeRef.current += 1;
      drawGrid(timeRef.current);
      animationFrame = requestAnimationFrame(animate);
    };

    window.addEventListener('resize', resize);
    resize();
    animate();

    return () => {
      window.removeEventListener('resize', resize);
      cancelAnimationFrame(animationFrame);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="fixed inset-0"
      style={{ 
        zIndex: 0,
        background: 'rgb(76, 29, 149)',
        width: '100vw',
        height: '100vh'
      }}
    />
  );
};

export default GridBackground;
